/**
 * Created by jomsm on 24/07/2017.
 */
(function () {

    'use strict';

    angular.module('Services').factory('serviceRateCardsTableService', serviceRateCardsTableService);

    function serviceRateCardsTableService(Carrier, TableLiteFactory, $filter, $location) {
        return function (carrierProfileId, serviceProfileId) {
            var tableData = {};
            var activeFilters = {};
            var paginationFilter = {};
            var sortingFilter = {
                page: 0
            };
            var tableStructure = {
                tableName: 'serviceRateCardsTable',
                /*optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'ADD NEW SERVICE RATE',
                        onClick: function () {
                            $location.path('/carriers/service-rates/new');
                        }
                    }]
                },*/
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtraction: true,
                    colMinWidth: '135px'
                },
                headers: [{
                    label: 'RATE CARD NAME',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'CARRIER ACCOUNT CODE',
                    viewName: 'carrierAccountCode',
                    filterName: 'carrierAccountCode',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        refresh: function (model) {
                            let selected = this.model;
                            let filterItems = this.items;
                            Carrier.getExternalCarrierProfiles((data)=>{
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile)=>{
                                    if(profile.id === carrierProfileId){
                                        selected.name = profile.name;
                                        //tableStructure.optionAddOns.select.model = profile;
                                        carrierProfileId = null;
                                    }
                                    filterItems.push(profile);
                                });
                            }, (error)=>{
                                console.log(error);
                            },{size:1000,name:model ? model : ''})
                        },
                        model: carrierProfileId ? {name:' '} : null,
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'SERVICE PROFILE',
                    viewName: 'serviceName',//to fix
                    filterName: 'serviceId',//to fix
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'displayName',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        refresh: function (model) {
                            let selected = this.model;
                            let filterItems = this.items;
                            Carrier.getServiceProfiles((data)=>{
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile)=>{
                                    if(profile.id === serviceProfileId){
                                        selected.displayName = profile.displayName;
                                        /*tableStructure.optionAddOns.select.model = profile;*/
                                        serviceProfileId = null;
                                    }
                                    filterItems.push(profile);
                                });
                            }, (error)=>{
                                console.log(error);
                            },{size:1000,name:model ? model : ''})
                        },
                        model: serviceProfileId ? {name:' '} : null,
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: [],
                applyFilters: function (item) {
                    angular.extend(paginationFilter, {
                        size: item,
                        page: 0
                    });
                    sendRequest();
                },
                extractTable: function (form) {

                },
                onPageChanged: function () {
                    angular.extend(paginationFilter, {
                        page: this.currentPage - 1
                    });
                    sendRequest();
                },
                resetFilters: resetFilters,
                onInit: function () {
                    let initReq = {
                        size: 20,
                        page: 0,
                        sort: 'createdDate,desc'
                    };
                    if(serviceProfileId)
                        initReq.serviceProfileId = serviceProfileId;
                    if(carrierProfileId)
                        initReq.carrierProfileId = carrierProfileId;
                    sendRequest(initReq);
                }
            };

            function sort(filterName) {
                if (tableData.sort && tableData.sort[0].property !== filterName) {
                    sortingFilter.sort = filterName;
                } else if (!tableData.sort || tableData.sort[0].property == filterName &&
                    !tableData.sort[0].direction.toLowerCase() == 'desc') {
                    sortingFilter.sort = filterName;
                } else if (tableData.sort[0].direction.toLowerCase() == 'asc') {
                    sortingFilter.sort = filterName + ',desc';
                } else if (tableData.sort[0].direction.toLowerCase() == 'desc') {
                    delete sortingFilter.sort;
                    delete paginationFilter.sort;
                    delete activeFilters.sort;
                }

                sendRequest(sortingFilter);
            }

            function resetFilters() {
                angular.forEach(tableStructure.headers, function (header) {
                    if (header.filter) {
                        if (header.filter.model)
                            header.filter.model = '';
                        delete activeFilters[header.filterName];
                    }
                });
                sendRequest({});
            };

            function evaluateFilter(header) {
                var filter = {};
                if (header.filter.model){
                    var filterBy = header.filter.model[header.filter.filterBy];
                    if(filterBy){
                        filter[header.filterName] = filterBy;
                    }else{
                        filter[header.filterName] = header.filter.model;
                    }
                }
                else if (activeFilters[header.filterName])
                    delete activeFilters[header.filterName];

                return filter;
            }

            function sendRequest(filter) {

                filter = sanitizeFilters(filter);

                angular.extend(activeFilters, paginationFilter, filter);
                var ids = [];
                Carrier.getServiceRateCards(function (data) {
                    tableData = buildTableData(data, activeFilters);
                }, function (err) {
                    tableData = buildTableData(null, activeFilters);
                }, activeFilters);
            };

            /**
             * @param {filterList} is a list of filter
             * @return {object} with key value pair, value should be string ONLY
             */
            function sanitizeFilters(filterList) {
                var filterClean = {};
                angular.forEach(filterList, function (item, key) {
                    if (_.has(item, 'value'))
                        filterClean[key] = item.value;
                    else
                        filterClean[key] = item;
                });

                return filterClean;
            };
            function buildTableData(data, pagination) {
                /*** START - Building of Data ***/
                if (pagination)

                    paginationFilter = pagination;

                tableData = tableStructure;
                tableData.data = [];

                angular.extend(tableData, TableLiteFactory.getCommonProperties(data));
                if (!data)
                    return tableData;

                angular.forEach(data.content, function (item, index) {
                    if (item.serviceDetails) {
                        item.carrierName = {
                            type: 'logotype',
                            imgSrc: item.serviceDetails.logo
                        };
                        item.serviceName = item.serviceDetails.serviceName;
                    }
                    item.carrierProfileName = item.carrierProfile.name;
                    item.href = '/carriers/service-rates/' + item.id;
                    tableData.data.push(item);
                });
                /*** END - Building of Data ***/
                return tableData;
            };
            this.tableData = tableStructure;
        }
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/serviceRateCardsTableService.js